import { useEffect, useState } from "react"
import CreateCompanyProgram from "./CreateCompanyProgram"
import MTable from "../../../../components/mtable"
import ProgramsQuotaCard from "./ProgramsQuotaCard"
import { getStorage, STORAGE } from "../../../../utils/storage"
import { useNavigate } from "react-router-dom"

export default function CompanyPrograms({companyId}) {
    
    const navigate = useNavigate()

    const [isCreate, setIsCreate] = useState(false)
    const onClose = () => setIsCreate(false)

    useEffect(() => {
        let isCreateSaved = getStorage(STORAGE.CREATE_PROGRAM_STEP)
        if (isCreateSaved) setIsCreate(true)
    }, [])

    const mapper = {columns: [
        {
            label: "Name",
            value: (item) => item.name
        },
        {
            label: "Tracks",
            value: (item) => item.tracks?.join(', ')
        }
    ]}

    const viewProgram = (program) => navigate(`programs/${program.id}`)

    return(
        <>
            <div className="flex space-between center gap-xs v-spacer-m">
                <p className="section-title">{isCreate ? 'Create Program' : 'Programs'}</p>
                {!isCreate && <button className="text" onClick={() => setIsCreate(true)}>Create</button>}
            </div>
            {!isCreate && <ProgramsQuotaCard companyId={companyId} />}
            {!isCreate && <MTable path={`companies/${companyId}/programs`} mapper={mapper} onClick={viewProgram}/>}
            {isCreate && <CreateCompanyProgram companyId={companyId} close={onClose}/> }             
        </>
    )
}